import { types } from "../types/types";

export const getPanelAgenda = (values) => ({
  type: types.getPanelAgenda,
  payload: values,
});

export const importDataAgenda = (agenda) => {
  return async (dispatch) => {
    try {
      dispatch(getPanelAgenda(agenda));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getUpdateAgendaNeeded = (data) => ({
  type: types.getUpdateAgendaNeeded,
  payload: data,
});

export const importAgendaUpdateNeeded = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateAgendaNeeded(data));
    } catch (e) {
      console.error(e);
    }
  };
};